// VFX: Save Reminder Pop
// Category: ui-elements · Tags: save, bookmark, reminder, instagram, cta
// Bookmark icon pops in with a "Save this!" nudge badge.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface SaveReminderProps {
  message?: string;
  accentColor?: string;
}

export default function SaveReminderPop({
  message = "Save this!",
  accentColor = "#a855f7",
}: SaveReminderProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const pop = spring({ frame, fps, config: { damping: 12, stiffness: 220, mass: 0.8 } });
  const badgeP = spring({ frame: frame - 6, fps, config: { damping: 16, stiffness: 200 } });
  const wiggle = Math.sin(frame * 0.25) * 5;
  return (
    <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", background: "linear-gradient(135deg, #0f172a, #1e1b4b)" }}>
      <div style={{ position: "relative", transform: `scale(${pop}) rotate(${wiggle}deg)`, opacity: pop }}>
        <svg width="180" height="220" viewBox="0 0 180 220">
          <path
            d="M30 12 H150 A12 12 0 0 1 162 24 V200 L90 160 L18 200 V24 A12 12 0 0 1 30 12 Z"
            fill={accentColor}
            stroke="#f8fafc"
            strokeWidth="6"
            style={{ filter: `drop-shadow(0 12px 32px ${accentColor}88)` }}
          />
        </svg>
        <div style={{
          position: "absolute",
          top: -28, right: -60,
          background: "#10b981",
          color: "#fff",
          padding: "10px 18px",
          borderRadius: 100,
          fontSize: 18,
          fontWeight: 800,
          fontFamily: "system-ui",
          transform: `scale(${badgeP}) rotate(12deg)`,
          opacity: badgeP,
          boxShadow: "0 8px 24px rgba(16,185,129,0.5)",
          whiteSpace: "nowrap",
        }}>
          {message}
        </div>
      </div>
      <div style={{
        marginTop: 60,
        fontSize: 28,
        fontWeight: 700,
        color: "#f8fafc",
        fontFamily: "system-ui",
        opacity: interpolate(frame, [12, 20], [0, 1], clamp),
        transform: `translateY(${interpolate(frame, [12, 20], [16, 0], clamp)}px)`,
        letterSpacing: 1,
      }}>
        Pra não esquecer →
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
